import React from "react";

const skillsContent = [
  { skillClass: "p95", skillPercent: "95", skillName: "HTML" },
  { skillClass: "p95", skillPercent: "95", skillName: "CSS" },
  { skillClass: "p90", skillPercent: "90", skillName: "SCSS" },
  { skillClass: "p89", skillPercent: "89", skillName: "JAVASCRIPT" },
  { skillClass: "p90", skillPercent: "90", skillName: "JQUERY" },
  { skillClass: "p85", skillPercent: "85", skillName: "ANGULAR" },
  { skillClass: "p75", skillPercent: "75", skillName: "REACT" },
  { skillClass: "p75", skillPercent: "75", skillName: "IONIC" },
  { skillClass: "p66", skillPercent: "68", skillName: "NODE" },
  { skillClass: "p66", skillPercent: "66", skillName: "PHP" },
  { skillClass: "p45", skillPercent: "45", skillName: "MySQL" },
  { skillClass: "p34", skillPercent: "34", skillName: "MongoDB" },
  { skillClass: "p89", skillPercent: "89", skillName: "Photoshop" },
  { skillClass: "p78", skillPercent: "78", skillName: "Illustrator" },
];

const Skills = () => {
  return (
    <>
      {skillsContent.map((val, i) => (
        <div className="col-6 col-md-3 mb-3 mb-sm-5" key={i}>
          <div className={`c100 ${val.skillClass}`}>
            <span>{val.skillPercent}%</span>
            <div className="slice">
              <div className="bar"></div>
              <div className="fill"></div>
            </div>
          </div>
          <h6 className="text-uppercase open-sans-font text-center mt-2 mt-sm-4">
            {val.skillName}
          </h6>
        </div>
      ))}
    </>
  );
};

export default Skills;
